import { SuggestionsList } from '../suggestions-list';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'fronton-react';
import { cx } from 'linaria';
import { SponsoredProductsItems, SponsoredProductsItemsProps } from './sponsored-products-items';
import { promoLabel, suggestionsList } from './styles';

export const DATA_QA_PROMO_LABEL = 'sponsored-products-promo-label';

type SponsoredProductsListProps = SponsoredProductsItemsProps & {
  isKzDomain: boolean;
  suggestionSelector: string;
};

export const SponsoredProductsList: React.FC<SponsoredProductsListProps> = ({
  isKzDomain,
  suggestionSelector,
  sponsoredProducts,
  ...itemsProps
}) => {
  const { t } = useTranslation();

  if (isKzDomain || sponsoredProducts.length === 0) return null;

  return (
    <SuggestionsList
      suggestionSelector={cx(suggestionsList, suggestionSelector)}
      dividers
      aria-label={t('header.searchbar.sponsored-aria')}
      data-qa={'sponsored-product-suggestions'}
    >
      <Typography
        variant="mini"
        size="overline"
        color="text-minor"
        className={cx(promoLabel, suggestionSelector)}
        data-qa={DATA_QA_PROMO_LABEL}
      >
        {t('header.searchbar.promo')}
      </Typography>
      <SponsoredProductsItems sponsoredProducts={sponsoredProducts} {...itemsProps} />
    </SuggestionsList>
  );
};
